import { UserInfo, UserState } from '@/utils/types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState = {
	user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!) : null,
	userInfo: localStorage.getItem('user-info') ? JSON.parse(localStorage.getItem('user-info')!) : null,
};

const authSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		login: (state, { payload }: PayloadAction<UserState>) => {
			localStorage.setItem('user', JSON.stringify(payload));
			return { ...state, user: payload };
		},
		setUserInfo: (state, { payload }: PayloadAction<UserInfo>) => {
			localStorage.setItem('user-info', JSON.stringify(payload));
			return { ...state, userInfo: payload };
		},
		logout: (state) => {
			localStorage.clear();
			return { user: null, userInfo: null };
		},
	},
});
export const { login, logout, setUserInfo } = authSlice.actions;
export default authSlice;
